// List of urban regions available in this dashboard
export const AVAILABLE_REGIONS = [
    'Baltimore',
    'Louisville/Jefferson County',
    'Memphis',
    'Las Vegas',
    'Detroit',
    'Portland',
    'Boston',
    'Oklahoma City',
    'El Paso',
    'Nashville-Davidson',
    'Washington',
    'Denver',
    'Seattle',
    'Charlotte',
    'San Francisco',
    'Indianapolis',
    'Columbus',
    'Fort Worth',
    'Jacksonville',
    'Austin',
    'San Jose',
    'Dallas',
    'San Diego',
    'San Antonio',
    'Phoenix',
    'Philadelphia',
    'Houston',
    'Chicago',
    'Los Angeles',
    'New York'
].sort();

export const CITY_CENTERS = {
    'Baltimore': [-76.61219, 39.29038],
    'Louisville/Jefferson County': [-85.75846, 38.25285],
    'Memphis': [-90.04898, 35.14953],
    'Las Vegas': [-115.13983, 36.16994],
    'Detroit': [-83.04575, 42.33143],
    'Portland': [-122.67621, 45.52345],
    'Boston': [-71.05888, 42.36008],
    'Oklahoma City': [-97.51643, 35.46756],
    'El Paso': [-106.48502, 31.76188],
    'Nashville-Davidson': [-86.78160, 36.16266],
    'Washington': [-77.03687, 38.90720],
    'Denver': [-104.99025, 39.73915],
    'Seattle': [-122.33207, 47.60621],
    'Charlotte': [-80.84313, 35.22709],
    'San Francisco': [-122.41942, 37.77493],
    'Indianapolis': [-86.15804, 39.76838],
    'Columbus': [-82.99879, 39.96118],
    'Fort Worth': [-97.33076, 32.75549],
    'Jacksonville': [-81.65565, 30.33218],
    'Austin': [-97.74306, 30.26715],
    'San Jose': [-121.88633, 37.33821],
    'Dallas': [-96.79699, 32.77666],
    'San Diego': [-117.16109, 32.71573],
    'San Antonio': [-98.49363, 29.42412],
    'Phoenix': [-112.07404, 33.44838],
    'Philadelphia': [-75.16522, 39.95258],
    'Houston': [-95.36980, 29.76043],
    'Chicago': [-87.62980, 41.87811],
    'Los Angeles': [-118.24368, 34.05223],
    'New York': [-73.935242, 40.730610]
};
